import { css } from '@emotion/react';

const deletedProductContainer = css`
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  div {
    border: solid 1px var(--jbmp-primary-color-40);
    height: 50px;
    width: 200px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: var(--jbmp-primary-color-80);
    padding: 20px;
    text-align: center;
  }
`;

export default {
  deletedProductContainer,
};
